import styled from '@emotion/styled';
import { spacing, typography } from 'component-library';

export const FormSection = styled.fieldset`
  margin-bottom: ${spacing.mediumLow};
  min-width: 0; // fixes ellipsis issue in flex container
  display: flex;
  flex-direction: column;
  gap: ${spacing.xsmall};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const FormSectionHeading = styled.h3`
  ${typography.body.largeBold};
`;
